// @ts-nocheck
// LIBRARY
import React from 'react';
import { Drawer } from 'antd';

// CUSTOM MODULES
import PageTitle from 'shared_components/page_title';
// import SearchPatientTable from 'shared_components/search_patient_table';
import SearchPatientTable from './search_table';
import Search from './search_form';
import SearchPatientTableHeader from './table_header';
import UpdatePatientForm from './edit_patient_info';
import { LabRequestContext } from 'context/labRequestContext';
import { moduleTitle, tablePageSize, drawerUpdateTitle } from './settings';

class SearchPatient extends React.Component {
	state = {
		patients: [],
		pageSize: tablePageSize,
		currentPage: 1,
		loading: false,
		showDrawer: false,
		patientInfo: null,
		//this state use for responsive drawer
		screenWidth: window.innerWidth,
		drawerWidth: '50%',
	};

	//for drawer responsive
	componentDidMount() {
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	handleResize = () => {
		this.setState({ screenWidth: window.innerWidth }, () => {
			if (this.state.screenWidth < 992) {
				this.setState({ drawerWidth: '80%' });
			} else {
				this.setState({ drawerWidth: '50%' });
			}
		});
	};

	resetCurrentPage = () => {
		this.setState({ currentPage: 1 });
	};

	handleTableChange = (pagination) => {
		const { current } = pagination;
		this.setState({ currentPage: current });
	};
	//

	handleChangeSize = pageSize => {
		this.setState({ pageSize });
	};

	populatePatients = patients => {
		this.setState({ patients });
	};

	displayLoading = isLoading => {
		this.setState({ loading: isLoading });
	};

	displayDrawer = patientRecord => {
		this.setState({
			showDrawer: true,
			patientInfo: patientRecord,
		});
	};

	onClosePatientResultDrawer = () => {
		this.setState({
			showDrawer: false,
		});
	};

	onSuccessUpdateInfo = () => {
		this.setState({
			showDrawer: false,
			patients: [],
		});
	};

	render() {
		const { patients, pageSize, currentPage, loading, showDrawer, patientInfo, drawerWidth } = this.state;
		return (
			<LabRequestContext.Provider value={{ resetCurrentPage: this.resetCurrentPage }}>
				<div>
					<PageTitle pageTitle={moduleTitle} />
					<div className="space-y-md"></div>
					<Search
						populatePatients={this.populatePatients}
						displayLoading={this.displayLoading}
						enableRequestDate={false}
					/>
					<div className="space-y-sm"></div>
					<SearchPatientTableHeader
						pageSize={pageSize}
						pageTotal={patients.length}
						currentPage={currentPage}
						handleChangeSize={this.handleChangeSize}
					/>
					<div className="space-y-sm"></div>
					<SearchPatientTable
						data={patients}
						pageSize={pageSize}
						currentPage={currentPage}
						loading={loading}
						handleDoubleClick={this.displayDrawer}
						onChange={this.handleTableChange}
						// redirectUrl=""
						// drawer={this.displayDrawer}
					/>
					{showDrawer ? (
						<Drawer
							title={drawerUpdateTitle}
							onClose={this.onClosePatientResultDrawer}
							width={drawerWidth}
							visible={showDrawer}
						>
							<UpdatePatientForm
								patientInfo={patientInfo}
								onCancel={this.onClosePatientResultDrawer}
								onSuccess={this.onSuccessUpdateInfo}
							/>
						</Drawer>
					) : null}
				</div>
			</LabRequestContext.Provider>
		);
	}
}

export default SearchPatient;
